import { render, staticRenderFns } from "./TextMessages.vue?vue&type=template&id=155579de&scoped=true&"
import script from "./TextMessages.vue?vue&type=script&lang=ts&"
export * from "./TextMessages.vue?vue&type=script&lang=ts&"
import style0 from "./TextMessages.vue?vue&type=style&index=0&id=155579de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155579de",
  null
  
)

export default component.exports